import { IconButton, Tooltip, Typography } from '@mui/material';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import { GridEntry } from '../entry/GridEntry';
import { useState } from 'react';

export const ProductEntry = ({id, name, barcode, description, handleChangeSearch})  =>
{
    const [duration, setDuration] = useState(0);
    const [temperature, setTemperature] = useState(0);

    function renderCardContent (name, barcode) {
      return (<>
        <Typography gutterBottom variant="h6" component="div">
          {name}
        </Typography>
        {!!barcode && (<Typography color='secondary' marginBottom={'10px'} alignItems={'center'} display={'flex'}><QrCode2Icon size='small' /> <span> &nbsp; &nbsp;&nbsp;{barcode}</span></Typography>)}
      </>
      )
    };

    function renderCardActions (id, handleChangeSearch) {

      const handleDelete = (id) => {
          const requestOptions = {
            method: 'DELETE'
          };
          fetch('/api/product/'+id, requestOptions)
          .then(r => handleChangeSearch({target: {value: ""}}))
          .catch(err => console.error(err));
      };

      return(<>
        <Tooltip title='Empfehlung anzeigen'>
          <IconButton href={'/recommendation/'+id} size="medium" color="secondary" aria-label='edit'>
              <InfoIcon fontSize='medium'/>
          </IconButton>
        </Tooltip>
        <Tooltip title='bearbeiten'>
          <IconButton href={"/product/edit/"+id} size="medium" color="secondary" aria-label="edit">
              <EditIcon fontSize="medium" />
          </IconButton>
        </Tooltip>
        <Tooltip title='löschen'>
          <IconButton onClick={(event)=> handleDelete(id)} size="medium" color="error" aria-label="delete">
              <DeleteIcon fontSize="medium" />
          </IconButton>
        </Tooltip>
      </>);
    };

    const onExpand = () => {
      const headers = new Headers();
      headers.append('Content-Type', 'accplication/json');
      const requestOptions = {
        method: 'GET',
        headers: headers
      };
      fetch('/api/recommendation?productId='+ id, requestOptions)
      .then(response => response.json())
      .then(json => {
        setDuration(json?.duration || 0);
        setTemperature(json?.temperature || 0);
        console.log(json?.duration);
        console.log(json?.temperature);
      })
      .catch(error => console.log(error));
    };

    function renderCardExpandedContent (description) {
      return (<>
        {!!(temperature === 0 || duration === 0) && (
          <Typography variant="body2" sx={{ color: 'secondary' }}>
            <strong>Leider können wir dir noch keine Empfehlung für dieses Produkt geben. Erstelle einen
              Erfahrungsbericht und hilf dabei, Erfahrungen mit diesem Produkt zu sammeln.
            </strong>
          </Typography>
        )}
        {!!(temperature > 0 && duration > 0) && (
          <>
            <Typography fontSize={18} variant="body2" sx={{ color: 'secondary' }}>
                <strong>Deine Empfehlung</strong>
            </Typography>
            <Typography fontSize={18} variant="body2" sx={{ color: 'secondary' }}>
                <strong>Temperatur:</strong> {temperature} °C
            </Typography>
            <Typography fontSize={18} variant="body2" sx={{ color: 'secondary' }}>
                <strong>Dauer:</strong> {duration} Minuten
            </Typography>
          </>
        )}
        <Typography variant="body2" sx={{ color: 'secondary' }}>
            <strong><br/>Beschreibung</strong>
        </Typography>
        <Typography variant="body2" sx={{ color: 'secondary' }}>
            {description}
        </Typography>
      </>);
    }

    return (
      <GridEntry
        cardContent={renderCardContent(name, barcode)}
        cardActions={renderCardActions(id, handleChangeSearch)}
        expandContent={renderCardExpandedContent(description)}
        onExpand={onExpand}
       />
    );
};